export default "__VITE_ASSET__oY3IZSrn__"